export default __webpack_public_path__ + "static/media/outside-right.d5f76bbd.mp4";